// extracted by mini-css-extract-plugin
export default {"container":"TouchDragLayer_container__sYPzJ"};